import {
  BankAccount,
  InvoiceClient,
  InvoiceCompany,
  InvoiceTask,
} from '__generated__/GQL';

// shared

export type FormClient = Pick<
  InvoiceClient,
  | 'city'
  | 'country'
  | 'invoiceClientId'
  | 'legalRegistrationNumber'
  | 'name'
  | 'street'
  | 'type'
  | 'vatId'
  | 'zip'
>;

export type FormCompany = Pick<
  InvoiceCompany,
  | 'city'
  | 'country'
  | 'isMicro'
  | 'legalForm'
  | 'legalName'
  | 'legalRegistrationNumber'
  | 'legalShareCapital'
  | 'legalVATNumber'
  | 'rcsNumber'
  | 'rmNumber'
  | 'street'
  | 'tradeName'
  | 'zip'
>;

export type InvoiceTaskWithoutTotal = Omit<
  InvoiceTask,
  '__typename' | 'totalAmountBeforeTaxes' | 'totalVatAmount'
>;

export type ConfirmType = 'save' | 'submit';

// invoice

export type FormInvoiceBankAccount = Pick<BankAccount, 'bic' | 'iban'>;

export enum SendingOptionsEnum {
  copyShareUrl = 'copy-share-url',
  downloadPdf = 'download-pdf',
  withShine = 'with-shine',
}
